import { Drafts } from '../../services/Drafts';

export const ADD_DRAFT = 'ADD_DRAFT';
export const REMOVE_DRAFT = 'REMOVE_DRAFT';
export const UPDATE_DRAFT = 'UPDATE_DRAFT';

export const SET_DRAFTS_FOR_BLOG = 'SET_DRAFTS_FOR_BLOG';

const PAGINATION_DEFAULT_PAGE = 1;
const PAGINATION_DEFAULT_LIMIT = 5;

export function addDraft(draft) {
  return {
    type: ADD_DRAFT,
    draft: draft
  };
}

export function removeDraft(id) {
  return {
    type: REMOVE_DRAFT,
    id: id
  };
}

export function updateDraft(draft) {
  return {
    type: UPDATE_DRAFT,
    draft: draft
  };
}

function setDraftsForBlog(drafts, metadata) {
  return {
    type: SET_DRAFTS_FOR_BLOG,
    drafts,
    metadata
  };
}

export const fetchDrafts = (blogId) => {
  return async (dispatch) => {
    try {
      const { data, metadata} = await Drafts.getAllPaginated(blogId, PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_LIMIT);
      dispatch(setDraftsForBlog(data, metadata));
    } catch (error) {
      console.log(error);     
    }
  }
}

export const fetchDraftsPaginated = (blogId, page, limit, sortBy, order) => {
  return async (dispatch) => {
    try {
      const {data, metadata} = await Drafts.getAllPaginated(blogId, page, limit, sortBy, order);
      dispatch(setDraftsForBlog(data, metadata));
    } catch (error) {
      console.log(error);     
    }
  }
}